// ============================================================
// MapApp.js — Carte Google Maps (colonne droite de l'écran)
// Affiche les parcs sous forme de pastilles colorées sur la carte.
// La colonne est masquée sous la largeur md (tablette) pour les
// petits écrans (classe d-none d-md-block depuis App.js).
// Applique les mêmes filtres que calls.js (statut, texte, expert).
// Gère également les trois modales (contrôle, suppression, modification)
// indépendamment de la liste.
// Props :
//   clients          — tableau de tous les parcs (depuis App.js)
//   filterControl    — filtre de statut (FILTER_*)
//   filterClient     — texte de recherche par nom
//   filterUserControl — filtre par expert
//   authtoken        — token Bearer Auth0
//   onRefresh        — callback pour recharger les parcs depuis App.js
// ============================================================

import React, { Component } from 'react';
import { getColor, filterParks } from './parkUtils';
import ParkControlModal from './ParkControlModal';
import ParkDeleteModal from './ParkDeleteModal';
import ParkEditModal from './ParkEditModal';
import GoogleMapReact from 'google-map-react'
// import 'google-map-react/dist/index.css'
import { apiSetControled, apiSetStandby, apiDeletePark } from './parkApi';
import Marker from './markers';

export default class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentClient: [], // Parc sélectionné via clic sur un marqueur
      isOpen: false,     // Modale de contrôle ouverte
      isOpen2: false,    // Modale de suppression ouverte
      isOpen3: false,    // Modale de modification ouverte
    };

  }

  // Centre et zoom par défaut : vue de la France entière
  static defaultProps = {
    center: {
      lat: 46.092483,
      lng: 2.444410
    },
    zoom: 6
  };

  // Valide le contrôle d'un parc depuis la carte,
  // puis ferme la modale et rafraîchit la liste
  setIsControled(id, ControlDate, userControl, exitStandby) {
    apiSetControled(this.props.authtoken, id, ControlDate, userControl, exitStandby)
        .then(() => { this.closeModal(); this.props.onRefresh(); })
        .catch(err => console.error('Erreur setIsControled:', err));
  }

  // Bascule l'état standby du parc depuis la carte
  setStandby(id) {
    apiSetStandby(this.props.authtoken, id)
        .then(() => { this.closeModal(); this.props.onRefresh(); })
        .catch(err => console.error('Erreur setStandby:', err));
  }

  // Supprime le parc depuis la carte, ferme les deux modales
  deletePark(id) {
    apiDeletePark(this.props.authtoken, id)
        .then(() => { this.closeModal(); this.closeModal2(); this.props.onRefresh(); })
        .catch(err => console.error('Erreur deletePark:', err));
  }

  // --- Gestion des modales ---
  openModal = (client) => this.setState({ isOpen: true, currentClient: client });
  closeModal = () => this.setState({ isOpen: false, currentClient: [] });

  // closeModal2/3 ne réinitialisent pas currentClient pour ne pas
  // effacer le nom du parc dans la modale principale encore ouverte
  openModal2 = (client) => this.setState({ isOpen2: true, currentClient: client });
  closeModal2 = () => this.setState({ isOpen2: false });
  openModal3 = (client) => this.setState({ isOpen3: true, currentClient: client });
  closeModal3 = () => this.setState({ isOpen3: false });


  render() {
    // Point de départ : tous les parcs reçus depuis App.js
    let filteredList = this.props.clients || [];

    // --- FILTRAGE (statut, texte, expert) ---
    filteredList = filterParks(filteredList, this.props.filterControl, this.props.filterClient, this.props.filterUserControl);

    // Version à jour du parc sélectionné : après un refresh (ex. modification),
    // les modales ouvertes reflètent les nouvelles données et non l'ancien snapshot
    const selected = this.state.currentClient;
    const currentClient = (selected && selected.id !== undefined
      && (this.props.clients || []).find(c => c.id === selected.id)) || selected;

    return (
      <>
        {/* Modale principale de contrôle — ouverte au clic sur un marqueur */}
        <ParkControlModal
          show={this.state.isOpen}
          onHide={this.closeModal}
          client={currentClient}
          experts={this.props.experts}
          onSetIsControled={(date, userControlId, exitStandby) => this.setIsControled(currentClient.id, date, userControlId, exitStandby)}
          onSetStandby={() => this.setStandby(currentClient.id)}
          onOpenDelete={(client) => this.openModal2(client)}
          onOpenEdit={(client) => this.openModal3(client)}
          role={this.props.role}
          userEmail={this.props.userEmail}
        />

        {/* Modale de confirmation de suppression */}
        <ParkDeleteModal
          show={this.state.isOpen2}
          onHide={this.closeModal2}
          client={currentClient}
          onDelete={() => this.deletePark(currentClient.id)}
        />

        {/* Modale de modification du parc */}
        <ParkEditModal
          show={this.state.isOpen3}
          onHide={this.closeModal3}
          client={currentClient}
          experts={this.props.experts}
          authtoken={this.props.authtoken}
          onRefresh={this.props.onRefresh}
        />

        {/* Carte Google Maps — clé API depuis la variable d'environnement */}
        <GoogleMapReact
          defaultZoom={6}
          defaultCenter={this.props.center}
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}>
          {/* Un marqueur coloré par parc filtré */}
          {filteredList.map((client) => (
            <Marker
              key={client.id}
              text={client.name}
              lat={client.lat}
              lng={client.lng}
              isControlled={client.isControlled}
              ControlDate={client.ControlDate}
              color={getColor(client)}  // Couleur calculée selon l'état du parc
              onClick={() => this.openModal(client)}
            />
          ))}
        </GoogleMapReact>
      </>
    )
  }
}
